import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { estaAberto, formatarHorarioFuncionamento } from '../../../utils/storeHours';

const StoreCard = ({ store }) => {
  const {
    id,
    nome,
    tipo,
    descricao,
    imagem,
    aberto,
    horarioFuncionamento,
    andar,
    whatsapp,
    redesSociais
  } = store;

  const isMercadoLivre = id === 'mercadoLivre';
  
  // Calcular se está aberto baseado no horário
  const isAberto = estaAberto(horarioFuncionamento);



  const handleContactClick = (e, type, contact) => {
    e?.preventDefault();
    e?.stopPropagation();
    
    if (type === 'phone') {
      window.open(`tel:${contact}`, '_self');
    } else if (type === 'whatsapp') {
      window.open(`https://wa.me/55${contact?.replace(/\D/g, '')}`, '_blank');
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-warm hover:shadow-warm-lg transition-all duration-300 overflow-hidden group h-[600px] flex flex-col">
      {/* Image Section with Background */}
      <div className="relative h-48 overflow-hidden flex-shrink-0 bg-card rounded-t-lg p-0.5">
        <Image
          src={imagem || "/assets/images/no_image.png"}
          alt={`Foto ${nome}`}
          className="w-full h-full object-cover rounded-t-md"
        />
        
        {/* Status Badge */}
        <div className="absolute top-3 left-3 z-20">
          <span className={`
            inline-flex items-center px-2 py-1 rounded-full text-xs font-medium backdrop-blur-sm
            ${isAberto 
              ? 'bg-success/90 text-success-foreground' 
              : 'bg-destructive/90 text-destructive-foreground'
            }
          `}>
            <div className={`w-2 h-2 rounded-full mr-1 ${isAberto ? 'bg-green-400' : 'bg-red-400'}`} />
            {isAberto ? 'Aberto' : 'Fechado'}
          </span>
        </div>
      </div>
      {/* Content Section */}
      <div className="p-4 flex-1 flex flex-col">
        {/* Header */}
        <div className="mb-2">
          <div className="flex items-center justify-between">
            <span className="text-[11px] text-muted-foreground flex-shrink-0 flex items-center gap-1">
              <Icon name="Building" size={10} />
              {andar}
            </span>
          </div>
        </div>

        {/* Nicho */}
        <div className="flex items-center gap-1.5 mb-2">
          <Icon name="Tag" size={12} className="text-primary" />
          <span className="text-sm text-primary font-semibold">
            {tipo}
          </span>
        </div>
        <div className="flex items-start justify-between gap-3 mb-2">
          <h3
            className="font-heading font-semibold text-foreground text-lg leading-tight"
            title={nome}
          >
            {nome}
          </h3>
          {redesSociais?.instagram && (
            <a
              href={redesSociais.instagram.startsWith('http') ? redesSociais.instagram : `https://instagram.com/${redesSociais.instagram.replace('@', '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:opacity-80"
              aria-label={`Instagram de ${nome}`}
              onClick={(e) => e.stopPropagation()}
            >
              <Icon name="Instagram" size={16} />
            </a>
          )}
        </div>
        {isMercadoLivre && (
          <div className="inline-flex items-center gap-1 rounded-full bg-foreground/10 px-2 py-1 text-[11px] font-medium text-foreground mb-2">
            <Icon name="ShoppingBag" size={12} className="text-primary" />
            Agência Mercado Livre
          </div>
        )}

        {/* Description */}
        <p 
          className="text-sm text-muted-foreground mb-2 line-clamp-2 flex-1 leading-relaxed"
          title={descricao}
        >
          {descricao}
        </p>

        {/* Opening Hours */}
        <div className="flex items-start gap-1.5 mb-3">
          <Icon name="Clock" size={12} className="text-muted-foreground mt-0.5 flex-shrink-0" />
          <span className="text-[10px] sm:text-xs text-muted-foreground leading-relaxed break-words">
            {formatarHorarioFuncionamento(horarioFuncionamento)}
          </span>
        </div>

        {/* Redes Sociais */}

        {/* Actions */}
        <div className="flex items-center gap-2 mt-auto">
          <Link 
            to={`/store-detail?id=${id}`}
            className="flex-1"
          >
            <Button variant="default" className="w-full h-10">
              Ver Detalhes
            </Button>
          </Link>
          
          {whatsapp && (
            <Button
              variant="outline"
              size="icon"
              onClick={(e) => handleContactClick(e, 'whatsapp', whatsapp)}
              className="h-10 w-10"
              aria-label={`WhatsApp: ${whatsapp}`}
            >
              <Icon name="Whatsapp" size={16} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoreCard;